import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '../../../styles';
import { mapStateToPropsHeader, mapDispatchToProps } from './redux';
import styles from './DetailHeader.styles';
import { CloseIcon } from '../../../components/icons';

import './styles.scss';

const propTypes = {
    styles: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    entityType: PropTypes.object,
};

@connect(mapStateToPropsHeader, mapDispatchToProps)
@withStyles(styles)
class DetailHeader extends Component {
    state = {};

    render() {
        let { onClose, styles } = this.props;
        return (
            <div className="react-detail-header">
                <div className="react-detail-header-close" onClick={onClose}>
                    <CloseIcon />
                </div>
            </div>
        );
    }
}

DetailHeader.propTypes = propTypes;

export default DetailHeader;
